import { render } from "./header.vue?vue&type=template&id=6abccc52&scoped=true&ts=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"

import "./header.vue?vue&type=style&index=0&id=6abccc52&scoped=true&lang=less"

import exportComponent from "/root/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abccc52"]])

export default __exports__